<template>
	<div class="loading" :class="[{'overlay': overlay, 'cover': cover}, variant] " v-if="show">
		<!-- <img :src="'/gifs/main-loading.gif'" alt="Loading"> -->
		<div class="image" v-if="variant == 'main'">
			<p v-if="message != ''" class="text-center text-xl font-medium mb-3 text-gray-500">{{ message }}</p>
			<img src="/gifs/main-loading.gif" class="mx-auto">
			<p class="text-sm text-gray-500 text-center" v-if="subtext">{{ subtext }}</p>
		</div>
		<div class="image" v-else-if="variant == 'mini'">
			<img src="/gifs/mini-loading.gif">
		</div>
		<div class="image" v-else-if="variant == 'price'">
			<img src="/gifs/price-loading.gif">
		</div>
	</div>
</template>

<script>
	export default {
		name: 'inc.loading',
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			variant: {
				type: String,
				default: 'main',
			},
			overlay: {
				type: Boolean,
				default: true
			},
			cover: {
				type: Boolean,
				default: false
			},
			message: {
				default: 'Loading...'
			},
			subtext: {
				default: ''
			}
		},
	}
</script>